module.exports = __webpack_public_path__ + "static/img/bg-id.dea6cd91.png";